import { DeferHandler } from './defer-handler.js';
export class IdleDeferHandler extends DeferHandler {
    setHandler() {
        const onload = new Promise((resolve) => {
            if (document.readyState !== 'complete') {
                window.addEventListener('load', () => {
                    resolve();
                }, { once: true });
            }
            else {
                resolve();
            }
        });
        if (!('requestIdleCallback' in window)) {
            // run immediately
            return onload;
        }
        // both idle and onload
        return Promise.all([
            new Promise((resolve) => {
                requestIdleCallback(() => {
                    resolve();
                });
            }),
            onload,
        ]);
    }
}
//# sourceMappingURL=idle-defer-handler.js.map